import React, { useEffect } from 'react'
import { subscribe } from 'react-contextual'
import { Helmet } from 'react-helmet'
import { useDispatch } from 'react-redux'
import {
  TableProvider,
  LayoutProvider,
  Layout,
  LayoutBody,
  LayoutContent,
  LayoutPrimaryPanel,
} from '../../../views/components'
import Properties from './Properties/Properties'
import PropertyView from './PropertyView/PropertyView'
import PropertiesProvider from '../PropertiesProvider'
import { layoutEvents } from '../../Layout/state'
import { NAMESPACE } from '../constants'

const PropertiesPage = ({ match: { params }, openProperty, resetLayout, pathname }: any) => {
  const dispatch = useDispatch()
  const propertyEditPath =
    /^\/properties\/([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})\/edit$/g
  const isEditPath = pathname.match(propertyEditPath)

  useEffect(() => {
    const propertyViewPath =
      /^\/properties\/([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})$/g

    if (params.id && isEditPath) {
      // On edit path - open the panel without triggering layout events
      dispatch(layoutEvents.openPrimaryPanel(NAMESPACE))
    } else if (params.id && pathname.match(propertyViewPath)) {
      openProperty(params.id)
    } else {
      resetLayout()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <LayoutProvider
      stateKey="properties"
      initialProps={{
        sidebar: { open: false, width: 0 },
        primaryPanel: { open: isEditPath ? true : false, width: 752 },
        secondaryPanel: { open: false, width: 375 },
      }}
    >
      <Helmet>
        <title>reOS | Properties</title>
      </Helmet>
      <Layout>
        <LayoutBody>
          <LayoutPrimaryPanel>{params.id ? <PropertyView /> : null}</LayoutPrimaryPanel>
          <LayoutContent>
            <TableProvider>
              <Properties />
            </TableProvider>
          </LayoutContent>
        </LayoutBody>
      </Layout>
    </LayoutProvider>
  )
}

export default subscribe(PropertiesProvider, ({ match, openProperty, resetLayout, pathname }: any) => ({
  match,
  openProperty,
  resetLayout,
  pathname,
}))(PropertiesPage)
